/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateEmailSettingsBody } from '../models';
// @ts-ignore
import type { CreateEmailTemplateBody } from '../models';
// @ts-ignore
import type { CreateEmailTypeBody } from '../models';
// @ts-ignore
import type { CreateMailTemplateBody } from '../models';
// @ts-ignore
import type { CreateMailTemplateResponse } from '../models';
// @ts-ignore
import type { DeleteTemplateResponse } from '../models';
// @ts-ignore
import type { EditEmailExperimentBody } from '../models';
// @ts-ignore
import type { EditEmailExperimentResponse } from '../models';
// @ts-ignore
import type { EmailGroupSegmentCountsResponse } from '../models';
// @ts-ignore
import type { EmailPauseStatus } from '../models';
// @ts-ignore
import type { EmailTypeDetailResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAllTemplatesResponse } from '../models';
// @ts-ignore
import type { GetEmailConversationResponse } from '../models';
// @ts-ignore
import type { GetEmailConversationsResponse } from '../models';
// @ts-ignore
import type { GetEmailGroupLogsListParam } from '../models';
// @ts-ignore
import type { GetEmailGroupLogsListResponse } from '../models';
// @ts-ignore
import type { GetEmailGroupThreadResponse } from '../models';
// @ts-ignore
import type { GetEmailGroupUsersListResponse } from '../models';
// @ts-ignore
import type { GetEmailSettingsResponse } from '../models';
// @ts-ignore
import type { GetEmailTypeDailyResponse } from '../models';
// @ts-ignore
import type { GetEmailTypesResponse } from '../models';
// @ts-ignore
import type { GetMailLogsResonse } from '../models';
// @ts-ignore
import type { GetTemplateByIdResponse } from '../models';
// @ts-ignore
import type { GetTemplatesListResponse } from '../models';
// @ts-ignore
import type { MailTemplateResponse } from '../models';
// @ts-ignore
import type { PauseEmailBody } from '../models';
// @ts-ignore
import type { PickAbWinnerBody } from '../models';
// @ts-ignore
import type { PickAbWinnerResponse } from '../models';
// @ts-ignore
import type { PreviewEmailTemplateBody } from '../models';
// @ts-ignore
import type { PreviewEmailTemplateResponse } from '../models';
// @ts-ignore
import type { ReseedEmailTemplatesBody } from '../models';
// @ts-ignore
import type { ReseedEmailTemplatesResponse } from '../models';
// @ts-ignore
import type { ResumeEmailBody } from '../models';
// @ts-ignore
import type { RideAlongResponse } from '../models';
// @ts-ignore
import type { SendEmailReplyBody } from '../models';
// @ts-ignore
import type { SendEmailReplyResponse } from '../models';
// @ts-ignore
import type { SendEmployerEmailBody } from '../models';
// @ts-ignore
import type { SendFollowUpBody } from '../models';
// @ts-ignore
import type { SendFollowUpResponse } from '../models';
// @ts-ignore
import type { SentEmailBody } from '../models';
// @ts-ignore
import type { SentEmailResponse } from '../models';
// @ts-ignore
import type { SetEmailTemplateAllocationBody } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UnsubscribeEmailBody } from '../models';
// @ts-ignore
import type { UpdateEmailGroupApprovalParam } from '../models';
// @ts-ignore
import type { UpdateEmailGroupAttributesParam } from '../models';
// @ts-ignore
import type { UpdateEmailSettingsBody } from '../models';
// @ts-ignore
import type { UpdateEmailTemplateBody } from '../models';
// @ts-ignore
import type { UpdateEmailTypeBody } from '../models';
/**
 * MailApiApi - axios parameter creator
 */
export const MailApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateEmailTemplateBody} createEmailTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiCreateDynamicEmailTemplate: async (createEmailTemplateBody: CreateEmailTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmailTemplateBody' is not null or undefined
            assertParamExists('mailApiCreateDynamicEmailTemplate', 'createEmailTemplateBody', createEmailTemplateBody)
            const localVarPath = `/admin/email-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmailTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateEmailSettingsBody} createEmailSettingsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiCreateEmailSettings: async (createEmailSettingsBody: CreateEmailSettingsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmailSettingsBody' is not null or undefined
            assertParamExists('mailApiCreateEmailSettings', 'createEmailSettingsBody', createEmailSettingsBody)
            const localVarPath = `/admin/email-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmailSettingsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateEmailTypeBody} createEmailTypeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiCreateEmailType: async (createEmailTypeBody: CreateEmailTypeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmailTypeBody' is not null or undefined
            assertParamExists('mailApiCreateEmailType', 'createEmailTypeBody', createEmailTypeBody)
            const localVarPath = `/admin/email-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmailTypeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateMailTemplateBody} createMailTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiCreateTemplate: async (createMailTemplateBody: CreateMailTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMailTemplateBody' is not null or undefined
            assertParamExists('mailApiCreateTemplate', 'createMailTemplateBody', createMailTemplateBody)
            const localVarPath = `/mail/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMailTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiDeleteDynamicEmailTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('mailApiDeleteDynamicEmailTemplate', 'templateId', templateId)
            const localVarPath = `/admin/email-templates/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiDeleteEmailGroup: async (emailGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailGroupId' is not null or undefined
            assertParamExists('mailApiDeleteEmailGroup', 'emailGroupId', emailGroupId)
            const localVarPath = `/admin/email-group/{email_group_id}/delete`
                .replace('{email_group_id}', encodeURIComponent(String(emailGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} typeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiDeleteEmailType: async (typeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('mailApiDeleteEmailType', 'typeId', typeId)
            const localVarPath = `/admin/email-types/{type_id}`
                .replace('{type_id}', encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiDeleteTemplateById: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('mailApiDeleteTemplateById', 'templateId', templateId)
            const localVarPath = `/mail/template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} experimentId 
         * @param {EditEmailExperimentBody} editEmailExperimentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiEditEmailExperiment: async (experimentId: string, editEmailExperimentBody: EditEmailExperimentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'experimentId' is not null or undefined
            assertParamExists('mailApiEditEmailExperiment', 'experimentId', experimentId)
            // verify required parameter 'editEmailExperimentBody' is not null or undefined
            assertParamExists('mailApiEditEmailExperiment', 'editEmailExperimentBody', editEmailExperimentBody)
            const localVarPath = `/admin/email-experiment/{experiment_id}/edit`
                .replace('{experiment_id}', encodeURIComponent(String(experimentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editEmailExperimentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetAllTemplates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mail/template-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailConversation: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('mailApiGetEmailConversation', 'email', email)
            const localVarPath = `/admin/email-conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailConversations: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/email-conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetEmailGroupLogsListParam} getEmailGroupLogsListParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailGroupLogsList: async (getEmailGroupLogsListParam: GetEmailGroupLogsListParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getEmailGroupLogsListParam' is not null or undefined
            assertParamExists('mailApiGetEmailGroupLogsList', 'getEmailGroupLogsListParam', getEmailGroupLogsListParam)
            const localVarPath = `/admin/email-group-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getEmailGroupLogsListParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailGroupSegmentCounts: async (emailGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailGroupId' is not null or undefined
            assertParamExists('mailApiGetEmailGroupSegmentCounts', 'emailGroupId', emailGroupId)
            const localVarPath = `/admin/email-group/{email_group_id}/segment-counts`
                .replace('{email_group_id}', encodeURIComponent(String(emailGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailGroupThread: async (emailGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailGroupId' is not null or undefined
            assertParamExists('mailApiGetEmailGroupThread', 'emailGroupId', emailGroupId)
            const localVarPath = `/admin/email-group/{email_group_id}/thread`
                .replace('{email_group_id}', encodeURIComponent(String(emailGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailGroupUsersList: async (emailGroupId: string, pageNo?: number, pageSize?: number, sortBy?: string, sortOrder?: string, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailGroupId' is not null or undefined
            assertParamExists('mailApiGetEmailGroupUsersList', 'emailGroupId', emailGroupId)
            const localVarPath = `/admin/email-group/{email_group_id}/users`
                .replace('{email_group_id}', encodeURIComponent(String(emailGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailSettings: async (id?: string, pageNo?: number, pageSize?: number, searchQuery?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/email-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} typeId 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailTypeDaily: async (typeId: string, days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('mailApiGetEmailTypeDaily', 'typeId', typeId)
            const localVarPath = `/admin/email-types/{type_id}/daily`
                .replace('{type_id}', encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} typeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailTypeDetail: async (typeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('mailApiGetEmailTypeDetail', 'typeId', typeId)
            const localVarPath = `/admin/email-types/{type_id}`
                .replace('{type_id}', encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean | null} [isActive] 
         * @param {string | null} [search] 
         * @param {MailApiGetEmailTypesWindowEnum} [window] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailTypes: async (isActive?: boolean | null, search?: string | null, window?: MailApiGetEmailTypesWindowEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/email-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [maxDate] 
         * @param {string} [minDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [recipient] 
         * @param {string} [sender] 
         * @param {string} [templateId] 
         * @param {string} [templateName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetMailsLogs: async (maxDate?: string, minDate?: string, pageNo?: number, pageSize?: number, recipient?: string, sender?: string, templateId?: string, templateName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/mail/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (maxDate !== undefined) {
                localVarQueryParameter['max_date'] = maxDate;
            }

            if (minDate !== undefined) {
                localVarQueryParameter['min_date'] = minDate;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (recipient !== undefined) {
                localVarQueryParameter['recipient'] = recipient;
            }

            if (sender !== undefined) {
                localVarQueryParameter['sender'] = sender;
            }

            if (templateId !== undefined) {
                localVarQueryParameter['template_id'] = templateId;
            }

            if (templateName !== undefined) {
                localVarQueryParameter['template_name'] = templateName;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetSendStatisticsApi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mail/get_statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetTemplateById: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('mailApiGetTemplateById', 'templateId', templateId)
            const localVarPath = `/mail/template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetTemplates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mail/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read-only and cheap enough to call on every tick of the ride-along checkboxes: it resolves the same way the send path does, so what the composer displays here is what the body will interpolate.
         * @summary What would ride along with this job, for the composer to show before sending.
         * @param {string} jobId 
         * @param {string} kinds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiJobRideAlong: async (jobId: string, kinds: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('mailApiJobRideAlong', 'jobId', jobId)
            // verify required parameter 'kinds' is not null or undefined
            assertParamExists('mailApiJobRideAlong', 'kinds', kinds)
            const localVarPath = `/mail/job-ride-along`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }

            if (kinds !== undefined) {
                localVarQueryParameter['kinds'] = kinds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PauseEmailBody} pauseEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiPauseEmail: async (pauseEmailBody: PauseEmailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pauseEmailBody' is not null or undefined
            assertParamExists('mailApiPauseEmail', 'pauseEmailBody', pauseEmailBody)
            const localVarPath = `/admin/email/pause`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pauseEmailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} experimentId 
         * @param {PickAbWinnerBody} pickAbWinnerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiPickAbWinner: async (experimentId: string, pickAbWinnerBody: PickAbWinnerBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'experimentId' is not null or undefined
            assertParamExists('mailApiPickAbWinner', 'experimentId', experimentId)
            // verify required parameter 'pickAbWinnerBody' is not null or undefined
            assertParamExists('mailApiPickAbWinner', 'pickAbWinnerBody', pickAbWinnerBody)
            const localVarPath = `/admin/email-experiment/{experiment_id}/winner`
                .replace('{experiment_id}', encodeURIComponent(String(experimentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pickAbWinnerBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PreviewEmailTemplateBody} previewEmailTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiPreviewDynamicEmailTemplate: async (previewEmailTemplateBody: PreviewEmailTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'previewEmailTemplateBody' is not null or undefined
            assertParamExists('mailApiPreviewDynamicEmailTemplate', 'previewEmailTemplateBody', previewEmailTemplateBody)
            const localVarPath = `/admin/email-templates/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewEmailTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReseedEmailTemplatesBody} reseedEmailTemplatesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiReseedEmailTemplates: async (reseedEmailTemplatesBody: ReseedEmailTemplatesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reseedEmailTemplatesBody' is not null or undefined
            assertParamExists('mailApiReseedEmailTemplates', 'reseedEmailTemplatesBody', reseedEmailTemplatesBody)
            const localVarPath = `/admin/email-types/reseed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reseedEmailTemplatesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResumeEmailBody} resumeEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiResumeEmail: async (resumeEmailBody: ResumeEmailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeEmailBody' is not null or undefined
            assertParamExists('mailApiResumeEmail', 'resumeEmailBody', resumeEmailBody)
            const localVarPath = `/admin/email/resume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeEmailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SentEmailBody} sentEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiSendEmailApi: async (sentEmailBody: SentEmailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sentEmailBody' is not null or undefined
            assertParamExists('mailApiSendEmailApi', 'sentEmailBody', sentEmailBody)
            const localVarPath = `/mail/send_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sentEmailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendEmailReplyBody} sendEmailReplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiSendEmailReply: async (sendEmailReplyBody: SendEmailReplyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendEmailReplyBody' is not null or undefined
            assertParamExists('mailApiSendEmailReply', 'sendEmailReplyBody', sendEmailReplyBody)
            const localVarPath = `/admin/email/reply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailReplyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendEmployerEmailBody} sendEmployerEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiSendEmployerEmailApi: async (sendEmployerEmailBody: SendEmployerEmailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendEmployerEmailBody' is not null or undefined
            assertParamExists('mailApiSendEmployerEmailApi', 'sendEmployerEmailBody', sendEmployerEmailBody)
            const localVarPath = `/mail/send_employer_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmployerEmailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {SendFollowUpBody} sendFollowUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiSendFollowUpEmail: async (emailGroupId: string, sendFollowUpBody: SendFollowUpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailGroupId' is not null or undefined
            assertParamExists('mailApiSendFollowUpEmail', 'emailGroupId', emailGroupId)
            // verify required parameter 'sendFollowUpBody' is not null or undefined
            assertParamExists('mailApiSendFollowUpEmail', 'sendFollowUpBody', sendFollowUpBody)
            const localVarPath = `/admin/email-group/{email_group_id}/follow-up`
                .replace('{email_group_id}', encodeURIComponent(String(emailGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendFollowUpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} typeId 
         * @param {SetEmailTemplateAllocationBody} setEmailTemplateAllocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiSetEmailTemplateAllocation: async (typeId: string, setEmailTemplateAllocationBody: SetEmailTemplateAllocationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('mailApiSetEmailTemplateAllocation', 'typeId', typeId)
            // verify required parameter 'setEmailTemplateAllocationBody' is not null or undefined
            assertParamExists('mailApiSetEmailTemplateAllocation', 'setEmailTemplateAllocationBody', setEmailTemplateAllocationBody)
            const localVarPath = `/admin/email-types/{type_id}/allocation`
                .replace('{type_id}', encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setEmailTemplateAllocationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnsubscribeEmailBody} unsubscribeEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUnsubscribeEmail: async (unsubscribeEmailBody: UnsubscribeEmailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unsubscribeEmailBody' is not null or undefined
            assertParamExists('mailApiUnsubscribeEmail', 'unsubscribeEmailBody', unsubscribeEmailBody)
            const localVarPath = `/mail/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unsubscribeEmailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {UpdateEmailTemplateBody} updateEmailTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateDynamicEmailTemplate: async (templateId: string, updateEmailTemplateBody: UpdateEmailTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('mailApiUpdateDynamicEmailTemplate', 'templateId', templateId)
            // verify required parameter 'updateEmailTemplateBody' is not null or undefined
            assertParamExists('mailApiUpdateDynamicEmailTemplate', 'updateEmailTemplateBody', updateEmailTemplateBody)
            const localVarPath = `/admin/email-templates/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {UpdateEmailGroupApprovalParam} updateEmailGroupApprovalParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateEmailGroupApproval: async (emailGroupId: string, updateEmailGroupApprovalParam: UpdateEmailGroupApprovalParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailGroupId' is not null or undefined
            assertParamExists('mailApiUpdateEmailGroupApproval', 'emailGroupId', emailGroupId)
            // verify required parameter 'updateEmailGroupApprovalParam' is not null or undefined
            assertParamExists('mailApiUpdateEmailGroupApproval', 'updateEmailGroupApprovalParam', updateEmailGroupApprovalParam)
            const localVarPath = `/admin/email-group/{email_group_id}/update-mail-approval`
                .replace('{email_group_id}', encodeURIComponent(String(emailGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailGroupApprovalParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {UpdateEmailGroupAttributesParam} updateEmailGroupAttributesParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateEmailGroupAttributes: async (emailGroupId: string, updateEmailGroupAttributesParam: UpdateEmailGroupAttributesParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailGroupId' is not null or undefined
            assertParamExists('mailApiUpdateEmailGroupAttributes', 'emailGroupId', emailGroupId)
            // verify required parameter 'updateEmailGroupAttributesParam' is not null or undefined
            assertParamExists('mailApiUpdateEmailGroupAttributes', 'updateEmailGroupAttributesParam', updateEmailGroupAttributesParam)
            const localVarPath = `/admin/email-group/{email_group_id}/update-mail-attributes`
                .replace('{email_group_id}', encodeURIComponent(String(emailGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailGroupAttributesParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailSettingId 
         * @param {UpdateEmailSettingsBody} updateEmailSettingsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateEmailSettings: async (emailSettingId: string, updateEmailSettingsBody: UpdateEmailSettingsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailSettingId' is not null or undefined
            assertParamExists('mailApiUpdateEmailSettings', 'emailSettingId', emailSettingId)
            // verify required parameter 'updateEmailSettingsBody' is not null or undefined
            assertParamExists('mailApiUpdateEmailSettings', 'updateEmailSettingsBody', updateEmailSettingsBody)
            const localVarPath = `/admin/email-settings/{email_setting_id}`
                .replace('{email_setting_id}', encodeURIComponent(String(emailSettingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailSettingsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} typeId 
         * @param {UpdateEmailTypeBody} updateEmailTypeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateEmailType: async (typeId: string, updateEmailTypeBody: UpdateEmailTypeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('mailApiUpdateEmailType', 'typeId', typeId)
            // verify required parameter 'updateEmailTypeBody' is not null or undefined
            assertParamExists('mailApiUpdateEmailType', 'updateEmailTypeBody', updateEmailTypeBody)
            const localVarPath = `/admin/email-types/{type_id}`
                .replace('{type_id}', encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailTypeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {CreateMailTemplateBody} createMailTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateTemplate: async (templateId: string, createMailTemplateBody: CreateMailTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('mailApiUpdateTemplate', 'templateId', templateId)
            // verify required parameter 'createMailTemplateBody' is not null or undefined
            assertParamExists('mailApiUpdateTemplate', 'createMailTemplateBody', createMailTemplateBody)
            const localVarPath = `/mail/template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMailTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MailApiApi - functional programming interface
 */
export const MailApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MailApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateEmailTemplateBody} createEmailTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiCreateDynamicEmailTemplate(createEmailTemplateBody: CreateEmailTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTypeDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiCreateDynamicEmailTemplate(createEmailTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiCreateDynamicEmailTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateEmailSettingsBody} createEmailSettingsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiCreateEmailSettings(createEmailSettingsBody: CreateEmailSettingsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiCreateEmailSettings(createEmailSettingsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiCreateEmailSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateEmailTypeBody} createEmailTypeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiCreateEmailType(createEmailTypeBody: CreateEmailTypeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTypeDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiCreateEmailType(createEmailTypeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiCreateEmailType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateMailTemplateBody} createMailTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiCreateTemplate(createMailTemplateBody: CreateMailTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateMailTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiCreateTemplate(createMailTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiCreateTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiDeleteDynamicEmailTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTypeDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiDeleteDynamicEmailTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiDeleteDynamicEmailTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiDeleteEmailGroup(emailGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiDeleteEmailGroup(emailGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiDeleteEmailGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} typeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiDeleteEmailType(typeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiDeleteEmailType(typeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiDeleteEmailType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiDeleteTemplateById(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiDeleteTemplateById(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiDeleteTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} experimentId 
         * @param {EditEmailExperimentBody} editEmailExperimentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiEditEmailExperiment(experimentId: string, editEmailExperimentBody: EditEmailExperimentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditEmailExperimentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiEditEmailExperiment(experimentId, editEmailExperimentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiEditEmailExperiment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetAllTemplates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetAllTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetAllTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetEmailConversation(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmailConversationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetEmailConversation(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetEmailConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetEmailConversations(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmailConversationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetEmailConversations(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetEmailConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetEmailGroupLogsListParam} getEmailGroupLogsListParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetEmailGroupLogsList(getEmailGroupLogsListParam: GetEmailGroupLogsListParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmailGroupLogsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetEmailGroupLogsList(getEmailGroupLogsListParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetEmailGroupLogsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetEmailGroupSegmentCounts(emailGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailGroupSegmentCountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetEmailGroupSegmentCounts(emailGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetEmailGroupSegmentCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetEmailGroupThread(emailGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmailGroupThreadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetEmailGroupThread(emailGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetEmailGroupThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetEmailGroupUsersList(emailGroupId: string, pageNo?: number, pageSize?: number, sortBy?: string, sortOrder?: string, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmailGroupUsersListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetEmailGroupUsersList(emailGroupId, pageNo, pageSize, sortBy, sortOrder, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetEmailGroupUsersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetEmailSettings(id?: string, pageNo?: number, pageSize?: number, searchQuery?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmailSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetEmailSettings(id, pageNo, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetEmailSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} typeId 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetEmailTypeDaily(typeId: string, days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmailTypeDailyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetEmailTypeDaily(typeId, days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetEmailTypeDaily']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} typeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetEmailTypeDetail(typeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTypeDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetEmailTypeDetail(typeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetEmailTypeDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean | null} [isActive] 
         * @param {string | null} [search] 
         * @param {MailApiGetEmailTypesWindowEnum} [window] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetEmailTypes(isActive?: boolean | null, search?: string | null, window?: MailApiGetEmailTypesWindowEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmailTypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetEmailTypes(isActive, search, window, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetEmailTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [maxDate] 
         * @param {string} [minDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [recipient] 
         * @param {string} [sender] 
         * @param {string} [templateId] 
         * @param {string} [templateName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetMailsLogs(maxDate?: string, minDate?: string, pageNo?: number, pageSize?: number, recipient?: string, sender?: string, templateId?: string, templateName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMailLogsResonse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetMailsLogs(maxDate, minDate, pageNo, pageSize, recipient, sender, templateId, templateName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetMailsLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetSendStatisticsApi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetSendStatisticsApi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetSendStatisticsApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetTemplateById(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTemplateByIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetTemplateById(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiGetTemplates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTemplatesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiGetTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiGetTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read-only and cheap enough to call on every tick of the ride-along checkboxes: it resolves the same way the send path does, so what the composer displays here is what the body will interpolate.
         * @summary What would ride along with this job, for the composer to show before sending.
         * @param {string} jobId 
         * @param {string} kinds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiJobRideAlong(jobId: string, kinds: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RideAlongResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiJobRideAlong(jobId, kinds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiJobRideAlong']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PauseEmailBody} pauseEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiPauseEmail(pauseEmailBody: PauseEmailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailPauseStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiPauseEmail(pauseEmailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiPauseEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} experimentId 
         * @param {PickAbWinnerBody} pickAbWinnerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiPickAbWinner(experimentId: string, pickAbWinnerBody: PickAbWinnerBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickAbWinnerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiPickAbWinner(experimentId, pickAbWinnerBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiPickAbWinner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PreviewEmailTemplateBody} previewEmailTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiPreviewDynamicEmailTemplate(previewEmailTemplateBody: PreviewEmailTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewEmailTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiPreviewDynamicEmailTemplate(previewEmailTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiPreviewDynamicEmailTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReseedEmailTemplatesBody} reseedEmailTemplatesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiReseedEmailTemplates(reseedEmailTemplatesBody: ReseedEmailTemplatesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReseedEmailTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiReseedEmailTemplates(reseedEmailTemplatesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiReseedEmailTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResumeEmailBody} resumeEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiResumeEmail(resumeEmailBody: ResumeEmailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailPauseStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiResumeEmail(resumeEmailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiResumeEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SentEmailBody} sentEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiSendEmailApi(sentEmailBody: SentEmailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SentEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiSendEmailApi(sentEmailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiSendEmailApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendEmailReplyBody} sendEmailReplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiSendEmailReply(sendEmailReplyBody: SendEmailReplyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendEmailReplyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiSendEmailReply(sendEmailReplyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiSendEmailReply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendEmployerEmailBody} sendEmployerEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiSendEmployerEmailApi(sendEmployerEmailBody: SendEmployerEmailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SentEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiSendEmployerEmailApi(sendEmployerEmailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiSendEmployerEmailApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {SendFollowUpBody} sendFollowUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiSendFollowUpEmail(emailGroupId: string, sendFollowUpBody: SendFollowUpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendFollowUpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiSendFollowUpEmail(emailGroupId, sendFollowUpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiSendFollowUpEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} typeId 
         * @param {SetEmailTemplateAllocationBody} setEmailTemplateAllocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiSetEmailTemplateAllocation(typeId: string, setEmailTemplateAllocationBody: SetEmailTemplateAllocationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTypeDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiSetEmailTemplateAllocation(typeId, setEmailTemplateAllocationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiSetEmailTemplateAllocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UnsubscribeEmailBody} unsubscribeEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiUnsubscribeEmail(unsubscribeEmailBody: UnsubscribeEmailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiUnsubscribeEmail(unsubscribeEmailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiUnsubscribeEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {UpdateEmailTemplateBody} updateEmailTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiUpdateDynamicEmailTemplate(templateId: string, updateEmailTemplateBody: UpdateEmailTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTypeDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiUpdateDynamicEmailTemplate(templateId, updateEmailTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiUpdateDynamicEmailTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {UpdateEmailGroupApprovalParam} updateEmailGroupApprovalParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiUpdateEmailGroupApproval(emailGroupId: string, updateEmailGroupApprovalParam: UpdateEmailGroupApprovalParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiUpdateEmailGroupApproval(emailGroupId, updateEmailGroupApprovalParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiUpdateEmailGroupApproval']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emailGroupId 
         * @param {UpdateEmailGroupAttributesParam} updateEmailGroupAttributesParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiUpdateEmailGroupAttributes(emailGroupId: string, updateEmailGroupAttributesParam: UpdateEmailGroupAttributesParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiUpdateEmailGroupAttributes(emailGroupId, updateEmailGroupAttributesParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiUpdateEmailGroupAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emailSettingId 
         * @param {UpdateEmailSettingsBody} updateEmailSettingsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiUpdateEmailSettings(emailSettingId: string, updateEmailSettingsBody: UpdateEmailSettingsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiUpdateEmailSettings(emailSettingId, updateEmailSettingsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiUpdateEmailSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} typeId 
         * @param {UpdateEmailTypeBody} updateEmailTypeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiUpdateEmailType(typeId: string, updateEmailTypeBody: UpdateEmailTypeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTypeDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiUpdateEmailType(typeId, updateEmailTypeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiUpdateEmailType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {CreateMailTemplateBody} createMailTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailApiUpdateTemplate(templateId: string, createMailTemplateBody: CreateMailTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailApiUpdateTemplate(templateId, createMailTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApiApi.mailApiUpdateTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MailApiApi - factory interface
 */
export const MailApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MailApiApiFp(configuration)
    return {
        /**
         * 
         * @param {MailApiApiMailApiCreateDynamicEmailTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiCreateDynamicEmailTemplate(requestParameters: MailApiApiMailApiCreateDynamicEmailTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailTypeDetailResponse> {
            return localVarFp.mailApiCreateDynamicEmailTemplate(requestParameters.createEmailTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiCreateEmailSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiCreateEmailSettings(requestParameters: MailApiApiMailApiCreateEmailSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.mailApiCreateEmailSettings(requestParameters.createEmailSettingsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiCreateEmailTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiCreateEmailType(requestParameters: MailApiApiMailApiCreateEmailTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailTypeDetailResponse> {
            return localVarFp.mailApiCreateEmailType(requestParameters.createEmailTypeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiCreateTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiCreateTemplate(requestParameters: MailApiApiMailApiCreateTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateMailTemplateResponse> {
            return localVarFp.mailApiCreateTemplate(requestParameters.createMailTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiDeleteDynamicEmailTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiDeleteDynamicEmailTemplate(requestParameters: MailApiApiMailApiDeleteDynamicEmailTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailTypeDetailResponse> {
            return localVarFp.mailApiDeleteDynamicEmailTemplate(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiDeleteEmailGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiDeleteEmailGroup(requestParameters: MailApiApiMailApiDeleteEmailGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.mailApiDeleteEmailGroup(requestParameters.emailGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiDeleteEmailTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiDeleteEmailType(requestParameters: MailApiApiMailApiDeleteEmailTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.mailApiDeleteEmailType(requestParameters.typeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiDeleteTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiDeleteTemplateById(requestParameters: MailApiApiMailApiDeleteTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteTemplateResponse> {
            return localVarFp.mailApiDeleteTemplateById(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiEditEmailExperimentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiEditEmailExperiment(requestParameters: MailApiApiMailApiEditEmailExperimentRequest, options?: RawAxiosRequestConfig): AxiosPromise<EditEmailExperimentResponse> {
            return localVarFp.mailApiEditEmailExperiment(requestParameters.experimentId, requestParameters.editEmailExperimentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetAllTemplates(options?: RawAxiosRequestConfig): AxiosPromise<GetAllTemplatesResponse> {
            return localVarFp.mailApiGetAllTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetEmailConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailConversation(requestParameters: MailApiApiMailApiGetEmailConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEmailConversationResponse> {
            return localVarFp.mailApiGetEmailConversation(requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetEmailConversationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailConversations(requestParameters: MailApiApiMailApiGetEmailConversationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetEmailConversationsResponse> {
            return localVarFp.mailApiGetEmailConversations(requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetEmailGroupLogsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailGroupLogsList(requestParameters: MailApiApiMailApiGetEmailGroupLogsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEmailGroupLogsListResponse> {
            return localVarFp.mailApiGetEmailGroupLogsList(requestParameters.getEmailGroupLogsListParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetEmailGroupSegmentCountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailGroupSegmentCounts(requestParameters: MailApiApiMailApiGetEmailGroupSegmentCountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailGroupSegmentCountsResponse> {
            return localVarFp.mailApiGetEmailGroupSegmentCounts(requestParameters.emailGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetEmailGroupThreadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailGroupThread(requestParameters: MailApiApiMailApiGetEmailGroupThreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEmailGroupThreadResponse> {
            return localVarFp.mailApiGetEmailGroupThread(requestParameters.emailGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetEmailGroupUsersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailGroupUsersList(requestParameters: MailApiApiMailApiGetEmailGroupUsersListRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEmailGroupUsersListResponse> {
            return localVarFp.mailApiGetEmailGroupUsersList(requestParameters.emailGroupId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetEmailSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailSettings(requestParameters: MailApiApiMailApiGetEmailSettingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetEmailSettingsResponse> {
            return localVarFp.mailApiGetEmailSettings(requestParameters.id, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetEmailTypeDailyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailTypeDaily(requestParameters: MailApiApiMailApiGetEmailTypeDailyRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEmailTypeDailyResponse> {
            return localVarFp.mailApiGetEmailTypeDaily(requestParameters.typeId, requestParameters.days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetEmailTypeDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailTypeDetail(requestParameters: MailApiApiMailApiGetEmailTypeDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailTypeDetailResponse> {
            return localVarFp.mailApiGetEmailTypeDetail(requestParameters.typeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetEmailTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetEmailTypes(requestParameters: MailApiApiMailApiGetEmailTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetEmailTypesResponse> {
            return localVarFp.mailApiGetEmailTypes(requestParameters.isActive, requestParameters.search, requestParameters.window, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetMailsLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetMailsLogs(requestParameters: MailApiApiMailApiGetMailsLogsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetMailLogsResonse> {
            return localVarFp.mailApiGetMailsLogs(requestParameters.maxDate, requestParameters.minDate, requestParameters.pageNo, requestParameters.pageSize, requestParameters.recipient, requestParameters.sender, requestParameters.templateId, requestParameters.templateName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetSendStatisticsApi(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mailApiGetSendStatisticsApi(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiGetTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetTemplateById(requestParameters: MailApiApiMailApiGetTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTemplateByIdResponse> {
            return localVarFp.mailApiGetTemplateById(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiGetTemplates(options?: RawAxiosRequestConfig): AxiosPromise<GetTemplatesListResponse> {
            return localVarFp.mailApiGetTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * Read-only and cheap enough to call on every tick of the ride-along checkboxes: it resolves the same way the send path does, so what the composer displays here is what the body will interpolate.
         * @summary What would ride along with this job, for the composer to show before sending.
         * @param {MailApiApiMailApiJobRideAlongRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiJobRideAlong(requestParameters: MailApiApiMailApiJobRideAlongRequest, options?: RawAxiosRequestConfig): AxiosPromise<RideAlongResponse> {
            return localVarFp.mailApiJobRideAlong(requestParameters.jobId, requestParameters.kinds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiPauseEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiPauseEmail(requestParameters: MailApiApiMailApiPauseEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailPauseStatus> {
            return localVarFp.mailApiPauseEmail(requestParameters.pauseEmailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiPickAbWinnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiPickAbWinner(requestParameters: MailApiApiMailApiPickAbWinnerRequest, options?: RawAxiosRequestConfig): AxiosPromise<PickAbWinnerResponse> {
            return localVarFp.mailApiPickAbWinner(requestParameters.experimentId, requestParameters.pickAbWinnerBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiPreviewDynamicEmailTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiPreviewDynamicEmailTemplate(requestParameters: MailApiApiMailApiPreviewDynamicEmailTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreviewEmailTemplateResponse> {
            return localVarFp.mailApiPreviewDynamicEmailTemplate(requestParameters.previewEmailTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiReseedEmailTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiReseedEmailTemplates(requestParameters: MailApiApiMailApiReseedEmailTemplatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReseedEmailTemplatesResponse> {
            return localVarFp.mailApiReseedEmailTemplates(requestParameters.reseedEmailTemplatesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiResumeEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiResumeEmail(requestParameters: MailApiApiMailApiResumeEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailPauseStatus> {
            return localVarFp.mailApiResumeEmail(requestParameters.resumeEmailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiSendEmailApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiSendEmailApi(requestParameters: MailApiApiMailApiSendEmailApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<SentEmailResponse> {
            return localVarFp.mailApiSendEmailApi(requestParameters.sentEmailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiSendEmailReplyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiSendEmailReply(requestParameters: MailApiApiMailApiSendEmailReplyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendEmailReplyResponse> {
            return localVarFp.mailApiSendEmailReply(requestParameters.sendEmailReplyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiSendEmployerEmailApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiSendEmployerEmailApi(requestParameters: MailApiApiMailApiSendEmployerEmailApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<SentEmailResponse> {
            return localVarFp.mailApiSendEmployerEmailApi(requestParameters.sendEmployerEmailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiSendFollowUpEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiSendFollowUpEmail(requestParameters: MailApiApiMailApiSendFollowUpEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendFollowUpResponse> {
            return localVarFp.mailApiSendFollowUpEmail(requestParameters.emailGroupId, requestParameters.sendFollowUpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiSetEmailTemplateAllocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiSetEmailTemplateAllocation(requestParameters: MailApiApiMailApiSetEmailTemplateAllocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailTypeDetailResponse> {
            return localVarFp.mailApiSetEmailTemplateAllocation(requestParameters.typeId, requestParameters.setEmailTemplateAllocationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiUnsubscribeEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUnsubscribeEmail(requestParameters: MailApiApiMailApiUnsubscribeEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.mailApiUnsubscribeEmail(requestParameters.unsubscribeEmailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiUpdateDynamicEmailTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateDynamicEmailTemplate(requestParameters: MailApiApiMailApiUpdateDynamicEmailTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailTypeDetailResponse> {
            return localVarFp.mailApiUpdateDynamicEmailTemplate(requestParameters.templateId, requestParameters.updateEmailTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiUpdateEmailGroupApprovalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateEmailGroupApproval(requestParameters: MailApiApiMailApiUpdateEmailGroupApprovalRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.mailApiUpdateEmailGroupApproval(requestParameters.emailGroupId, requestParameters.updateEmailGroupApprovalParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiUpdateEmailGroupAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateEmailGroupAttributes(requestParameters: MailApiApiMailApiUpdateEmailGroupAttributesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.mailApiUpdateEmailGroupAttributes(requestParameters.emailGroupId, requestParameters.updateEmailGroupAttributesParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiUpdateEmailSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateEmailSettings(requestParameters: MailApiApiMailApiUpdateEmailSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.mailApiUpdateEmailSettings(requestParameters.emailSettingId, requestParameters.updateEmailSettingsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiUpdateEmailTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateEmailType(requestParameters: MailApiApiMailApiUpdateEmailTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailTypeDetailResponse> {
            return localVarFp.mailApiUpdateEmailType(requestParameters.typeId, requestParameters.updateEmailTypeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MailApiApiMailApiUpdateTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailApiUpdateTemplate(requestParameters: MailApiApiMailApiUpdateTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MailTemplateResponse> {
            return localVarFp.mailApiUpdateTemplate(requestParameters.templateId, requestParameters.createMailTemplateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for mailApiCreateDynamicEmailTemplate operation in MailApiApi.
 */
export interface MailApiApiMailApiCreateDynamicEmailTemplateRequest {
    readonly createEmailTemplateBody: CreateEmailTemplateBody
}

/**
 * Request parameters for mailApiCreateEmailSettings operation in MailApiApi.
 */
export interface MailApiApiMailApiCreateEmailSettingsRequest {
    readonly createEmailSettingsBody: CreateEmailSettingsBody
}

/**
 * Request parameters for mailApiCreateEmailType operation in MailApiApi.
 */
export interface MailApiApiMailApiCreateEmailTypeRequest {
    readonly createEmailTypeBody: CreateEmailTypeBody
}

/**
 * Request parameters for mailApiCreateTemplate operation in MailApiApi.
 */
export interface MailApiApiMailApiCreateTemplateRequest {
    readonly createMailTemplateBody: CreateMailTemplateBody
}

/**
 * Request parameters for mailApiDeleteDynamicEmailTemplate operation in MailApiApi.
 */
export interface MailApiApiMailApiDeleteDynamicEmailTemplateRequest {
    readonly templateId: string
}

/**
 * Request parameters for mailApiDeleteEmailGroup operation in MailApiApi.
 */
export interface MailApiApiMailApiDeleteEmailGroupRequest {
    readonly emailGroupId: string
}

/**
 * Request parameters for mailApiDeleteEmailType operation in MailApiApi.
 */
export interface MailApiApiMailApiDeleteEmailTypeRequest {
    readonly typeId: string
}

/**
 * Request parameters for mailApiDeleteTemplateById operation in MailApiApi.
 */
export interface MailApiApiMailApiDeleteTemplateByIdRequest {
    readonly templateId: string
}

/**
 * Request parameters for mailApiEditEmailExperiment operation in MailApiApi.
 */
export interface MailApiApiMailApiEditEmailExperimentRequest {
    readonly experimentId: string

    readonly editEmailExperimentBody: EditEmailExperimentBody
}

/**
 * Request parameters for mailApiGetEmailConversation operation in MailApiApi.
 */
export interface MailApiApiMailApiGetEmailConversationRequest {
    readonly email: string
}

/**
 * Request parameters for mailApiGetEmailConversations operation in MailApiApi.
 */
export interface MailApiApiMailApiGetEmailConversationsRequest {
    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for mailApiGetEmailGroupLogsList operation in MailApiApi.
 */
export interface MailApiApiMailApiGetEmailGroupLogsListRequest {
    readonly getEmailGroupLogsListParam: GetEmailGroupLogsListParam
}

/**
 * Request parameters for mailApiGetEmailGroupSegmentCounts operation in MailApiApi.
 */
export interface MailApiApiMailApiGetEmailGroupSegmentCountsRequest {
    readonly emailGroupId: string
}

/**
 * Request parameters for mailApiGetEmailGroupThread operation in MailApiApi.
 */
export interface MailApiApiMailApiGetEmailGroupThreadRequest {
    readonly emailGroupId: string
}

/**
 * Request parameters for mailApiGetEmailGroupUsersList operation in MailApiApi.
 */
export interface MailApiApiMailApiGetEmailGroupUsersListRequest {
    readonly emailGroupId: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly totalPages?: number
}

/**
 * Request parameters for mailApiGetEmailSettings operation in MailApiApi.
 */
export interface MailApiApiMailApiGetEmailSettingsRequest {
    readonly id?: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly searchQuery?: string | null
}

/**
 * Request parameters for mailApiGetEmailTypeDaily operation in MailApiApi.
 */
export interface MailApiApiMailApiGetEmailTypeDailyRequest {
    readonly typeId: string

    readonly days?: number
}

/**
 * Request parameters for mailApiGetEmailTypeDetail operation in MailApiApi.
 */
export interface MailApiApiMailApiGetEmailTypeDetailRequest {
    readonly typeId: string
}

/**
 * Request parameters for mailApiGetEmailTypes operation in MailApiApi.
 */
export interface MailApiApiMailApiGetEmailTypesRequest {
    readonly isActive?: boolean | null

    readonly search?: string | null

    readonly window?: MailApiGetEmailTypesWindowEnum
}

/**
 * Request parameters for mailApiGetMailsLogs operation in MailApiApi.
 */
export interface MailApiApiMailApiGetMailsLogsRequest {
    readonly maxDate?: string

    readonly minDate?: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly recipient?: string

    readonly sender?: string

    readonly templateId?: string

    readonly templateName?: string
}

/**
 * Request parameters for mailApiGetTemplateById operation in MailApiApi.
 */
export interface MailApiApiMailApiGetTemplateByIdRequest {
    readonly templateId: string
}

/**
 * Request parameters for mailApiJobRideAlong operation in MailApiApi.
 */
export interface MailApiApiMailApiJobRideAlongRequest {
    readonly jobId: string

    readonly kinds: string
}

/**
 * Request parameters for mailApiPauseEmail operation in MailApiApi.
 */
export interface MailApiApiMailApiPauseEmailRequest {
    readonly pauseEmailBody: PauseEmailBody
}

/**
 * Request parameters for mailApiPickAbWinner operation in MailApiApi.
 */
export interface MailApiApiMailApiPickAbWinnerRequest {
    readonly experimentId: string

    readonly pickAbWinnerBody: PickAbWinnerBody
}

/**
 * Request parameters for mailApiPreviewDynamicEmailTemplate operation in MailApiApi.
 */
export interface MailApiApiMailApiPreviewDynamicEmailTemplateRequest {
    readonly previewEmailTemplateBody: PreviewEmailTemplateBody
}

/**
 * Request parameters for mailApiReseedEmailTemplates operation in MailApiApi.
 */
export interface MailApiApiMailApiReseedEmailTemplatesRequest {
    readonly reseedEmailTemplatesBody: ReseedEmailTemplatesBody
}

/**
 * Request parameters for mailApiResumeEmail operation in MailApiApi.
 */
export interface MailApiApiMailApiResumeEmailRequest {
    readonly resumeEmailBody: ResumeEmailBody
}

/**
 * Request parameters for mailApiSendEmailApi operation in MailApiApi.
 */
export interface MailApiApiMailApiSendEmailApiRequest {
    readonly sentEmailBody: SentEmailBody
}

/**
 * Request parameters for mailApiSendEmailReply operation in MailApiApi.
 */
export interface MailApiApiMailApiSendEmailReplyRequest {
    readonly sendEmailReplyBody: SendEmailReplyBody
}

/**
 * Request parameters for mailApiSendEmployerEmailApi operation in MailApiApi.
 */
export interface MailApiApiMailApiSendEmployerEmailApiRequest {
    readonly sendEmployerEmailBody: SendEmployerEmailBody
}

/**
 * Request parameters for mailApiSendFollowUpEmail operation in MailApiApi.
 */
export interface MailApiApiMailApiSendFollowUpEmailRequest {
    readonly emailGroupId: string

    readonly sendFollowUpBody: SendFollowUpBody
}

/**
 * Request parameters for mailApiSetEmailTemplateAllocation operation in MailApiApi.
 */
export interface MailApiApiMailApiSetEmailTemplateAllocationRequest {
    readonly typeId: string

    readonly setEmailTemplateAllocationBody: SetEmailTemplateAllocationBody
}

/**
 * Request parameters for mailApiUnsubscribeEmail operation in MailApiApi.
 */
export interface MailApiApiMailApiUnsubscribeEmailRequest {
    readonly unsubscribeEmailBody: UnsubscribeEmailBody
}

/**
 * Request parameters for mailApiUpdateDynamicEmailTemplate operation in MailApiApi.
 */
export interface MailApiApiMailApiUpdateDynamicEmailTemplateRequest {
    readonly templateId: string

    readonly updateEmailTemplateBody: UpdateEmailTemplateBody
}

/**
 * Request parameters for mailApiUpdateEmailGroupApproval operation in MailApiApi.
 */
export interface MailApiApiMailApiUpdateEmailGroupApprovalRequest {
    readonly emailGroupId: string

    readonly updateEmailGroupApprovalParam: UpdateEmailGroupApprovalParam
}

/**
 * Request parameters for mailApiUpdateEmailGroupAttributes operation in MailApiApi.
 */
export interface MailApiApiMailApiUpdateEmailGroupAttributesRequest {
    readonly emailGroupId: string

    readonly updateEmailGroupAttributesParam: UpdateEmailGroupAttributesParam
}

/**
 * Request parameters for mailApiUpdateEmailSettings operation in MailApiApi.
 */
export interface MailApiApiMailApiUpdateEmailSettingsRequest {
    readonly emailSettingId: string

    readonly updateEmailSettingsBody: UpdateEmailSettingsBody
}

/**
 * Request parameters for mailApiUpdateEmailType operation in MailApiApi.
 */
export interface MailApiApiMailApiUpdateEmailTypeRequest {
    readonly typeId: string

    readonly updateEmailTypeBody: UpdateEmailTypeBody
}

/**
 * Request parameters for mailApiUpdateTemplate operation in MailApiApi.
 */
export interface MailApiApiMailApiUpdateTemplateRequest {
    readonly templateId: string

    readonly createMailTemplateBody: CreateMailTemplateBody
}

/**
 * MailApiApi - object-oriented interface
 */
export class MailApiApi extends BaseAPI {
    /**
     * 
     * @param {MailApiApiMailApiCreateDynamicEmailTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiCreateDynamicEmailTemplate(requestParameters: MailApiApiMailApiCreateDynamicEmailTemplateRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiCreateDynamicEmailTemplate(requestParameters.createEmailTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiCreateEmailSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiCreateEmailSettings(requestParameters: MailApiApiMailApiCreateEmailSettingsRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiCreateEmailSettings(requestParameters.createEmailSettingsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiCreateEmailTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiCreateEmailType(requestParameters: MailApiApiMailApiCreateEmailTypeRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiCreateEmailType(requestParameters.createEmailTypeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiCreateTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiCreateTemplate(requestParameters: MailApiApiMailApiCreateTemplateRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiCreateTemplate(requestParameters.createMailTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiDeleteDynamicEmailTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiDeleteDynamicEmailTemplate(requestParameters: MailApiApiMailApiDeleteDynamicEmailTemplateRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiDeleteDynamicEmailTemplate(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiDeleteEmailGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiDeleteEmailGroup(requestParameters: MailApiApiMailApiDeleteEmailGroupRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiDeleteEmailGroup(requestParameters.emailGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiDeleteEmailTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiDeleteEmailType(requestParameters: MailApiApiMailApiDeleteEmailTypeRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiDeleteEmailType(requestParameters.typeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiDeleteTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiDeleteTemplateById(requestParameters: MailApiApiMailApiDeleteTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiDeleteTemplateById(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiEditEmailExperimentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiEditEmailExperiment(requestParameters: MailApiApiMailApiEditEmailExperimentRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiEditEmailExperiment(requestParameters.experimentId, requestParameters.editEmailExperimentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetAllTemplates(options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetAllTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetEmailConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetEmailConversation(requestParameters: MailApiApiMailApiGetEmailConversationRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetEmailConversation(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetEmailConversationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetEmailConversations(requestParameters: MailApiApiMailApiGetEmailConversationsRequest = {}, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetEmailConversations(requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetEmailGroupLogsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetEmailGroupLogsList(requestParameters: MailApiApiMailApiGetEmailGroupLogsListRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetEmailGroupLogsList(requestParameters.getEmailGroupLogsListParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetEmailGroupSegmentCountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetEmailGroupSegmentCounts(requestParameters: MailApiApiMailApiGetEmailGroupSegmentCountsRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetEmailGroupSegmentCounts(requestParameters.emailGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetEmailGroupThreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetEmailGroupThread(requestParameters: MailApiApiMailApiGetEmailGroupThreadRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetEmailGroupThread(requestParameters.emailGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetEmailGroupUsersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetEmailGroupUsersList(requestParameters: MailApiApiMailApiGetEmailGroupUsersListRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetEmailGroupUsersList(requestParameters.emailGroupId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetEmailSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetEmailSettings(requestParameters: MailApiApiMailApiGetEmailSettingsRequest = {}, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetEmailSettings(requestParameters.id, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetEmailTypeDailyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetEmailTypeDaily(requestParameters: MailApiApiMailApiGetEmailTypeDailyRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetEmailTypeDaily(requestParameters.typeId, requestParameters.days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetEmailTypeDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetEmailTypeDetail(requestParameters: MailApiApiMailApiGetEmailTypeDetailRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetEmailTypeDetail(requestParameters.typeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetEmailTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetEmailTypes(requestParameters: MailApiApiMailApiGetEmailTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetEmailTypes(requestParameters.isActive, requestParameters.search, requestParameters.window, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetMailsLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetMailsLogs(requestParameters: MailApiApiMailApiGetMailsLogsRequest = {}, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetMailsLogs(requestParameters.maxDate, requestParameters.minDate, requestParameters.pageNo, requestParameters.pageSize, requestParameters.recipient, requestParameters.sender, requestParameters.templateId, requestParameters.templateName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetSendStatisticsApi(options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetSendStatisticsApi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiGetTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetTemplateById(requestParameters: MailApiApiMailApiGetTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetTemplateById(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiGetTemplates(options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiGetTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read-only and cheap enough to call on every tick of the ride-along checkboxes: it resolves the same way the send path does, so what the composer displays here is what the body will interpolate.
     * @summary What would ride along with this job, for the composer to show before sending.
     * @param {MailApiApiMailApiJobRideAlongRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiJobRideAlong(requestParameters: MailApiApiMailApiJobRideAlongRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiJobRideAlong(requestParameters.jobId, requestParameters.kinds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiPauseEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiPauseEmail(requestParameters: MailApiApiMailApiPauseEmailRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiPauseEmail(requestParameters.pauseEmailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiPickAbWinnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiPickAbWinner(requestParameters: MailApiApiMailApiPickAbWinnerRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiPickAbWinner(requestParameters.experimentId, requestParameters.pickAbWinnerBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiPreviewDynamicEmailTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiPreviewDynamicEmailTemplate(requestParameters: MailApiApiMailApiPreviewDynamicEmailTemplateRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiPreviewDynamicEmailTemplate(requestParameters.previewEmailTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiReseedEmailTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiReseedEmailTemplates(requestParameters: MailApiApiMailApiReseedEmailTemplatesRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiReseedEmailTemplates(requestParameters.reseedEmailTemplatesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiResumeEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiResumeEmail(requestParameters: MailApiApiMailApiResumeEmailRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiResumeEmail(requestParameters.resumeEmailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiSendEmailApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiSendEmailApi(requestParameters: MailApiApiMailApiSendEmailApiRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiSendEmailApi(requestParameters.sentEmailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiSendEmailReplyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiSendEmailReply(requestParameters: MailApiApiMailApiSendEmailReplyRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiSendEmailReply(requestParameters.sendEmailReplyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiSendEmployerEmailApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiSendEmployerEmailApi(requestParameters: MailApiApiMailApiSendEmployerEmailApiRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiSendEmployerEmailApi(requestParameters.sendEmployerEmailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiSendFollowUpEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiSendFollowUpEmail(requestParameters: MailApiApiMailApiSendFollowUpEmailRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiSendFollowUpEmail(requestParameters.emailGroupId, requestParameters.sendFollowUpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiSetEmailTemplateAllocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiSetEmailTemplateAllocation(requestParameters: MailApiApiMailApiSetEmailTemplateAllocationRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiSetEmailTemplateAllocation(requestParameters.typeId, requestParameters.setEmailTemplateAllocationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiUnsubscribeEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiUnsubscribeEmail(requestParameters: MailApiApiMailApiUnsubscribeEmailRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiUnsubscribeEmail(requestParameters.unsubscribeEmailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiUpdateDynamicEmailTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiUpdateDynamicEmailTemplate(requestParameters: MailApiApiMailApiUpdateDynamicEmailTemplateRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiUpdateDynamicEmailTemplate(requestParameters.templateId, requestParameters.updateEmailTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiUpdateEmailGroupApprovalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiUpdateEmailGroupApproval(requestParameters: MailApiApiMailApiUpdateEmailGroupApprovalRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiUpdateEmailGroupApproval(requestParameters.emailGroupId, requestParameters.updateEmailGroupApprovalParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiUpdateEmailGroupAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiUpdateEmailGroupAttributes(requestParameters: MailApiApiMailApiUpdateEmailGroupAttributesRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiUpdateEmailGroupAttributes(requestParameters.emailGroupId, requestParameters.updateEmailGroupAttributesParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiUpdateEmailSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiUpdateEmailSettings(requestParameters: MailApiApiMailApiUpdateEmailSettingsRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiUpdateEmailSettings(requestParameters.emailSettingId, requestParameters.updateEmailSettingsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiUpdateEmailTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiUpdateEmailType(requestParameters: MailApiApiMailApiUpdateEmailTypeRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiUpdateEmailType(requestParameters.typeId, requestParameters.updateEmailTypeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailApiApiMailApiUpdateTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailApiUpdateTemplate(requestParameters: MailApiApiMailApiUpdateTemplateRequest, options?: RawAxiosRequestConfig) {
        return MailApiApiFp(this.configuration).mailApiUpdateTemplate(requestParameters.templateId, requestParameters.createMailTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const MailApiGetEmailTypesWindowEnum = {
    _24h: '24h',
    _7d: '7d',
    _30d: '30d',
    All: 'all',
} as const;
export type MailApiGetEmailTypesWindowEnum = typeof MailApiGetEmailTypesWindowEnum[keyof typeof MailApiGetEmailTypesWindowEnum];
